function escaparHtml(valor) {
  return String(valor == null ? '' : valor)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function formatarMoeda(valor) {
  if (valor === null || valor === undefined || valor === '') {
    return '';
  }
  const numero = Number(valor);
  return Number.isFinite(numero)
    ? numero.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    : '';
}

function obterItens(pedido) {
  return (
    pedido.itens ||
    pedido.items ||
    pedido.produtos ||
    pedido.itensPedido ||
    pedido.itemsPedido ||
    []
  );
}

function obterDescricao(item) {
  const produto = item.prod || item.produto || {};
  return (
    item.descr ||
    item.descricao ||
    item.nome ||
    produto.descr ||
    produto.descricao ||
    produto.nome ||
    `Produto ${item.codAlt || item.idProd || produto.id || ''}`
  );
}

function renderizarItens(itens) {
  if (!itens.length) {
    return '<p class="aviso">Nenhum item encontrado para este pedido.</p>';
  }

  const linhas = itens
    .map((item) => {
      const quantidade = Number(item.qtde || item.quantidade || 0);
      const desconto = Number(item.alqDesc || item.desconto || 0);
      const produto = item.prod || item.produto || {};
      const valorListaRaw =
        item.vlrUnit != null
          ? item.vlrUnit
          : item.valorUnitario != null
          ? item.valorUnitario
          : produto.vlrVenda;
      const valorLista = Number(valorListaRaw);
      const valorUnitarioLiq = Number(
        item.vlrUnitLiq != null
          ? item.vlrUnitLiq
          : Number.isFinite(valorLista)
          ? valorLista * (1 - desconto / 100)
          : NaN
      );
      const valorTotal =
        item.vlrTotLiq != null
          ? item.vlrTotLiq
          : item.valorTotal != null
          ? item.valorTotal
          : Number.isFinite(valorUnitarioLiq)
          ? valorUnitarioLiq * quantidade
          : null;
      const valorTotalComIpi =
        item.vlrTotIPI != null
          ? item.vlrTotIPI
          : item.valorTotalComIpi != null
          ? item.valorTotalComIpi
          : valorTotal != null && Number.isFinite(Number(valorTotal))
          ? Number(valorTotal) + Number(item.vlrIPI || 0)
          : null;

      return `<tr>
        <td>${escaparHtml(item.codAlt || item.codigo || '')}</td>
        <td>${escaparHtml(obterDescricao(item))}${item.descrCompl ? `<br><small>${escaparHtml(item.descrCompl)}</small>` : ''}</td>
        <td class="numero">${escaparHtml(quantidade || '')}</td>
        <td class="numero">${escaparHtml(desconto ? `${desconto}%` : '')}</td>
        <td class="numero">${escaparHtml(formatarMoeda(valorUnitarioLiq))}</td>
        <td class="numero">${escaparHtml(formatarMoeda(valorTotal))}</td>
        <td class="numero">${escaparHtml(formatarMoeda(valorLista))}</td>
        <td class="numero">${escaparHtml(formatarMoeda(valorTotalComIpi))}</td>
      </tr>`;
    })
    .join('');

  return `<table>
    <thead><tr>
      <th>Código</th><th>Produto</th><th class="numero">Qtde.</th>
      <th class="numero">Desc.(%)</th><th class="numero">Valor Liq.</th>
      <th class="numero">Valor Total</th><th class="numero">Valor Lista</th>
      <th class="numero">Total c/ IPI</th>
    </tr></thead>
    <tbody>${linhas}</tbody>
  </table>`;
}

function renderizarDetalhes(pedido) {
  const detalhes = [
    ['Representante', pedido.representante || pedido.idRep],
    ['Condição de pagamento', pedido.condicao || pedido.descrCond || pedido.idCond],
    ['Transportadora', pedido.transportadora || pedido.nomeTrp || pedido.idTrp],
    ['Previsão de entrega', pedido.dataPrev],
    ['Valor dos produtos', formatarMoeda(pedido.vlrProd)],
    ['Frete', formatarMoeda(pedido.vlrFrete)],
    ['IPI', formatarMoeda(pedido.vlrIPI)],
    ['Observações', pedido.obs || pedido.observacao],
  ].filter(([, valor]) => valor !== undefined && valor !== null && valor !== '');

  return detalhes
    .map(
      ([rotulo, valor]) =>
        `<div class="detalhe"><strong>${escaparHtml(rotulo)}:</strong> ${escaparHtml(valor)}</div>`
    )
    .join('');
}

export function gerarHtmlPedido(pedido) {
  const itens = obterItens(pedido);
  const conteudo = `<!doctype html>
    <html lang="pt-BR">
      <head>
        <meta charset="utf-8">
        <meta name="viewport" content="width=device-width, initial-scale=1">
        <title>Pedido ${escaparHtml(pedido.id)}</title>
        <style>
          * { box-sizing: border-box; }
          body { color: #222; font: 14px Arial, sans-serif; margin: 24px; }
          h1 { font-size: 22px; margin: 0 0 18px; }
          h2 { border-bottom: 1px solid #ccc; font-size: 16px; margin: 24px 0 10px; padding-bottom: 6px; }
          .cabecalho, .detalhes { display: grid; gap: 8px 18px; grid-template-columns: repeat(2, minmax(0, 1fr)); }
          .detalhe { overflow-wrap: anywhere; }
          table { border-collapse: collapse; width: 100%; }
          th, td { border: 1px solid #bbb; padding: 7px; text-align: left; }
          th { background: #eee; }
          .numero { text-align: right; white-space: nowrap; }
          .aviso { color: #8a4b00; }
          @media (max-width: 600px) {
            body { margin: 14px; }
            .cabecalho, .detalhes { grid-template-columns: 1fr; }
            table { font-size: 12px; }
            th, td { padding: 5px 3px; }
          }
          @media print {
            body { margin: 0; }
            .aviso { color: #222; }
            tr { page-break-inside: avoid; }
          }
        </style>
      </head>
      <body>
        <h1>Pedido ${escaparHtml(pedido.id)}</h1>
        <div class="cabecalho">
          <div><strong>Cliente:</strong> ${escaparHtml(pedido.cliente)}</div>
          <div><strong>Data:</strong> ${escaparHtml(pedido.data)}</div>
          <div><strong>Status:</strong> ${escaparHtml(pedido.status)}</div>
          <div><strong>Origem:</strong> ${escaparHtml(pedido.origem)}</div>
          <div><strong>Valor do pedido:</strong> ${escaparHtml(formatarMoeda(pedido.vlr))}</div>
        </div>
        <div class="detalhes">${renderizarDetalhes(pedido)}</div>
        <h2>Itens do pedido</h2>
        ${renderizarItens(Array.isArray(itens) ? itens : [])}
      </body>
    </html>`;

  return conteudo;
}
